import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=52db9bae&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&id=52db9bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db9bae",
  null
  
)

export default component.exports